<template>
  <base-center-popup class="image-popup" v-bind="$attrs" v-on="$listeners">
    <div class="image-popup-comp" :style="{ width: `${width / 12}rem` }">
      <div class="wrapper">
        <img class="image" :src="url" width="100%" alt="" />

        <slot>
          <img
            class="btn-ok image"
            :src="okBtnParams.image"
            :style="okBtnStyle"
            :alt="okBtnParams.text"
            @click="ok"
            v-if="okBtnParams && okBtnParams.image"
          />

          <kd-button class="btn-ok" type="text" :style="okBtnStyle" @click="ok" v-else-if="okBtnParams">
            {{ okBtnParams.text || '确定' }}
          </kd-button>
        </slot>
      </div>
    </div>

    <template #postfix v-if="okBtnParams && okBtnParams.tips">
      <p class="tips">{{ okBtnParams.tips }}</p>
    </template>
  </base-center-popup>
</template>

<script setup lang="ts">
import { KdButton } from 'kuaidong-ui'
import { computed, onUnmounted, ref } from 'vue'
import { IImagePopupCancelBtnParams, IImagePopupOkBtnParams } from '../models/ui'

import BaseCenterPopup from './BaseCenterPopup.vue'

const props = withDefaults(
  defineProps<{
    url: string
    width?: number
    okBtnParams?: IImagePopupOkBtnParams | null
    cancelBtnParams?: IImagePopupCancelBtnParams | null
  }>(),
  {
    width: 315,
    okBtnParams: null,
    cancelBtnParams: null,
  }
)

const emits = defineEmits(['ok', 'close', 'cancel', 'update:visible'])

const isOK = ref(false)

const okBtnStyle = computed(() => {
  const { top, bottom, width, height, borderRadius } = props.okBtnParams || {}

  return {
    top: top && `${top / 12}rem`,
    bottom: bottom && `${bottom / 12}rem`,
    width: width && `${width / 12}rem`,
    height: height && `${height / 12}rem`,
    borderRadius: borderRadius && typeof borderRadius === 'number' ? `${borderRadius / 12}rem` : borderRadius,
  }
})

onUnmounted(() => {
  emits('close')

  if (!isOK.value) {
    emits('cancel')
    props.cancelBtnParams?.cancalAction?.()
  }
})

function ok() {
  emits('ok')
  isOK.value = true
  emits('update:visible', false)
  props.okBtnParams?.okAction?.()
}
</script>

<style lang="less">
.image-popup {
  > .kd-popup__main {
    > .kd-popup__content {
      > .tips {
        white-space: pre-line;
        margin: 32px 0 0 0;
        line-height: 20px;
        font-size: 14px;
        color: #fff;
      }
    }
  }
}

.image-popup-comp {
  margin: 0 auto;
  width: 315px;
  box-sizing: border-box;

  > .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;

    > .image {
      display: block;
      margin: 0 auto;
    }

    > .btn-ok {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      opacity: 0;

      &.image {
        opacity: 1;
      }
    }
  }
}
</style>
